// Enter your Api path 
export const apiPath = window.globalConfig.LegalAPIUrl;
// Custom headers
export const config = {
    headers: {
        'Authorization': 'API_KEY ' + window.globalConfig.LegalAPIKey
    }
}
export const configForFormData = {
    headers: {
        'Authorization': 'API_KEY ' + window.globalConfig.LegalAPIKey
    },
    maxBodyLength: Infinity,
    maxContentLength: Infinity
}
export const configForDownloadBlob = {
    headers: {
        'Authorization': 'API_KEY ' + window.globalConfig.LegalAPIKey
    },
    responseType: 'blob'
}
// Api endpoints with proper data
export const endPoints = {
    portalSettings: { endPoint: "/getportalsettings" },
    userApi: { endPoint: "/getuserinfo" },
    consentSave: { endPoint: "/updateconsent" },
    loginNews: { endPoint: "/login/getnews" },
    dashBoardNews: { endPoint: "/dashboard/getnews" },
    news: { endPoint: "/getnews" },
    getArea: { endPoint: "/getareas" },
    getRelationships: { endPoint: "/getrelationships" },
    getGeografiskBosteds: { endPoint: "/geografiskBosteds" },
    getBranches: { endPoint: "/getbranches" },
    getLawyer: { endPoint: "/getlawyers" },
    booking: { endPoint: "/booking" },
    getProfile: { endPoint: "/getprofileinfo" },
    saveProfile: { endPoint: "/updateprofile" },
    getAllCase: { endPoint: "/cases" },
    getCaseDetails: { endPoint: "/cases/legalcase" },
    uploadDocument: { endPoint: "/casedocument/upload" },
    allDocumentList: { endPoint: "/cases/getalldocuments" },
    createThread: { endPoint: "/case/threads" },
    allThread: { endPoint: "/case/allthreads" },
    getChat: { endPoint: "/case/messages" },
    createChat: { endPoint: "/case/messages" },
    updateChat: { endPoint: "/case/updateMessage" },
    getPendingSurvey: { endPoint: "/survey" },
    getSurvey: { endPoint: "/survey/details" },
    getPublicSurvey: { endPoint: "/publicsurvey/details" },
    postSurvey: { endPoint: "/survey/details" },
    getloginurl: { endPoint: "/getloginurl" },
    callbackforbankid: { endPoint: "/callbackforbankid" },
    callbackforsurveysigning: { endPoint: "/survey/callback" },
    checkvalidmarketsourceguid: { endPoint: "/checkvalidmarketsource" },
    createcase: { endPoint: "/createcase" },
    getSurveyResponses: { endPoint: "/responses" },
    getPublicSurveyResponses: { endPoint: "/publicsurvey/responses" },
    storeSurveyResponses: { endPoint: "/storeresponses" }
};

//Norway date time format
export const dateTimeFormat = { dateFormat: "DD.MM.YYYY, HH.mm", TimeFormat: "HH:mm", dateOnlyFormat: "DD.MM.YYYY" }
